import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

const createEchoStub = () => ({
    connector: {
        pusher: {
            connection: {
                state: 'unavailable',
                bind() {},
                unbind() {},
            },
        },
    },
    channel() {
        return {
            listen() {
                return this;
            },
            unsubscribe() {},
        };
    },
    private() {
        return {
            listen() {
                return this;
            },
            unsubscribe() {},
        };
    },
    leave() {},
    disconnect() {},
});

const configuredHost = import.meta.env.VITE_REVERB_HOST;
const configuredPort = Number(import.meta.env.VITE_REVERB_PORT || 8080);
const configuredScheme = import.meta.env.VITE_REVERB_SCHEME || 'https';
const currentHostname = window.location.hostname;
const currentScheme = window.location.protocol === 'https:' ? 'https' : 'http';
const isExposeHost = currentHostname.endsWith('.sharedwithexpose.com');
const usesLoopbackHost = ['127.0.0.1', '0.0.0.0', 'localhost'].includes(configuredHost);
const shouldUseCurrentOrigin = usesLoopbackHost && currentHostname !== configuredHost;
const reverbHost = shouldUseCurrentOrigin ? currentHostname : configuredHost;
const reverbScheme = shouldUseCurrentOrigin ? currentScheme : configuredScheme;
const reverbPort = shouldUseCurrentOrigin ? (reverbScheme === 'https' ? 443 : 80) : configuredPort;

window.Echo = isExposeHost
    ? createEchoStub()
    : new Echo({
        broadcaster: 'reverb',
        key:  import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: reverbHost,
        wsPort: reverbPort,
        wssPort: reverbPort,
        forceTLS: reverbScheme === 'https',
        enabledTransports: ['ws', 'wss'],
    });
